<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
.fixHeightScrollable {
  overflow: auto;
  height: 500px;
}
</style>

<template>
  <div>
    <b-form validated @submit="onSubmit" @reset="onReset">
      <div class="d-flex justify-content-between">
        <h5></h5>
        <div>
          <b-button-group v-if="editableOps">
            <b-button type="submit" variant="outline-primary" size="sm"
              ><span v-if="form.intId === undefined">Save</span><span v-else>Update</span></b-button
            >
            <b-button type="reset" variant="outline-danger" size="sm"
              >Reset</b-button
            >
          </b-button-group>
        </div>
      </div>
    </b-form>
    <br />
    <div class="overflow-auto">
      <div>
        <hr />
        <div class="fixHeightScrollable">
          <h5 style="text-align: center">General Work Report </h5>
          <hr />
          <b-form-group
            id="input-group-reportNo"
            label="Report no:"
            label-for="input-reportNo"
          >
            <b-form-input
              id="input-reportNo"
              v-model="form.reportNo"
              type="number"
              placeholder="Enter Report no"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-reportDate"
            label="Report date:"
            label-for="input-reportDate"
          >
            <b-form-input
              id="input-reportDate"
              v-model="form.reportDate"
              type="date"
              placeholder="Enter Report date"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-description"
            label="Description:"
            label-for="input-description"
          >
            <b-form-input
              id="input-description"
              v-model="form.description"
              type="text"
              placeholder="Enter Description"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-rigOperation"
            label="Rig operation:"
            label-for="input-rigOperation"
          >
            <b-form-input
              id="input-rigOperation"
              v-model="form.rigOperation"
              type="text"
              placeholder="Enter Rig operation"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <!-- <b-form-group id="input-group-locked" label="Locked?" label-for="input-locked" description="">
            <b-form-checkbox id="input-locked"  v-model="form.locked" type="number" placeholder="Enter Locked" :value="1" :unchecked-value="0" :disabled="!editable"></b-form-checkbox>
          </b-form-group> -->
          <hr />
          <h5 style="text-align: center">General</h5>
          <hr />
          <b-form-group
            id="input-group-jobType"
            label="Job type:"
            label-for="input-jobType"
          >
            <b-form-input
              id="input-jobType"
              v-model="form.jobType"
              type="search"
              list="input-jobType-list-id"
              placeholder="Enter Job type"
              :disabled="!editable"
            ></b-form-input>
            <datalist id="input-jobType-list-id">
              <option
                v-for="option in optionComboJobType"
                :key="option.value"
                >{{ option.text }}</option
              >
            </datalist>
          </b-form-group>
          <b-form-group
            id="input-group-objective"
            label="Objective:"
            label-for="input-objective"
          >
            <b-form-input
              id="input-objective"
              v-model="form.objective"
              type="text"
              placeholder="Enter Objective"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-jobStartDatetime"
            label="Job start datetime:"
            label-for="input-jobStartDatetime"
          >
            <b-form-input
              id="input-jobStartDatetime"
              v-model="form.jobStartDatetime"
              type="datetime-local"
              placeholder="Enter Job start datetime"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-jobEndDatetime"
            label="Job end datetime:"
            label-for="input-jobEndDatetime"
          >
            <b-form-input
              id="input-jobEndDatetime"
              v-model="form.jobEndDatetime"
              type="datetime-local"
              placeholder="Enter Job end datetime"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-estDays"
            label="Est days:"
            label-for="input-estDays"
          >
            <b-form-input
              id="input-estDays"
              v-model="form.estDays"
              type="number"
              step="0.001"
              placeholder="Enter Est days"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-estCost"
            label="Est cost:"
            label-for="input-estCost"
          >
            <b-form-input
              id="input-estCost"
              v-model="form.estCost"
              type="number"
              step="0.001"
              placeholder="Enter Est cost"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-actualDays"
            label="Actual days:"
            label-for="input-actualDays"
          >
            <b-form-input
              id="input-actualDays"
              v-model="form.actualDays"
              type="number"
              step="0.001"
              placeholder="Enter Actual days"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-actualCost"
            label="Actual cost:"
            label-for="input-actualCost"
          >
            <b-form-input
              id="input-actualCost"
              v-model="form.actualCost"
              type="number"
              step="0.001"
              placeholder="Enter Actual cost"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-contractor"
            label="Contractor:"
            label-for="input-contractor"
          >
            <b-form-input
              id="input-contractor"
              v-model="form.contractor"
              type="text"
              placeholder="Enter Contractor"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-supervisor1"
            label="Supervisor 1:"
            label-for="input-supervisor1"
          >
            <b-form-input
              id="input-supervisor1"
              v-model="form.supervisor1"
              type="text"
              placeholder="Enter Supervisor 1"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-supervisor2"
            label="Supervisor 2:"
            label-for="input-supervisor2"
          >
            <b-form-input
              id="input-supervisor2"
              v-model="form.supervisor2"
              type="text"
              placeholder="Enter Supervisor 2"
              :disabled="!editable"
            ></b-form-input>
          </b-form-group>
          <hr />
          <h5 style="text-align: center">Operation</h5>
          <hr />
          <GeneralWorkOps :submit-id="submitId" :editable-ops="editable" />
          <hr />
          <h5 style="text-align: center">Remarks</h5>
          <hr />
          <b-form-group
            id="input-group-remarks"
            label="Remarks:"
            label-for="input-remarks"
            style="width: 100%"
          >
            <b-form-textarea
              id="input-remarks"
              v-model="form.remarks"
              type="text"
              rows="5"
              placeholder="Enter Remarks"
              :disabled="!editable"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <!-- end of div form -->
        <hr />
      </div>

      <!-- <p>{{ selectedRow }}</p> -->
    </div>
  </div>

  <!-- MODALS -->
</template>

<script>
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import { formMethods, formComputed } from '@state/helpers'
import GeneralWorkOps from '@components/form/drilling-activity/general-work-ops'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import notify from "devextreme/ui/notify"

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueFormGenerator)

export default {
  components: { GeneralWorkOps },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {type: Number, default: undefined},
    editable: Boolean,
    wellId: {type: Number, default: undefined},
  },
  data() {
    return {
      form: [],
      show: true,
      hasData: false,
      isSidewallCoring: true,
      editableOps: this.editable,
      optionComboJobType: [],
    }
  },
  computed: {
    ...formComputed,
  },
  watch: {
    submitId: function (value) {
      this.init()
    },
    editable: function (val) {
      this.editableOps = val
    },
    form: function (val) {},
  },
  created: function () {
    this.init()
  },
  methods: {
    ...formMethods,
    init() {
      this.loadAllCombo()
      this.form = []
      this.getActivityGeneralWorkFix({
        params: { submitId: this.submitId },
      }).then((resp) => {
        if (resp.data.data.length > 0) {
          this.hasData = true
          this.form = resp.data.data[0]
        }
        console.log('this.hasData', this.hasData)
      })
    },
    loadAllCombo() {
      this.optionComboJobType = []
      let dataCombo = [{ combo_name: 'job_type_gw', ref_id: '' }]

      dataCombo.forEach((data) => {
        this.getComboOptionList({
          params: {
            form_id: 'general_work',
            combo_name: data.combo_name,
            ref_id: data.ref_id,
          },
        }).then((resp) => {
          resp.data.data.forEach((d) => {
            this.optionComboJobType.push({
              value: d.comboId,
              text: d.comboValue,
            })
          })
        })
      })

      this.getActivityGeneralWorkJobType({
        params: { wellId: this.wellId },
      }).then((resp) => {
        if (resp) {
          resp.data.data.forEach((d) => {
            if (
              !this.optionComboJobType.find((data) => {
                return d === data.value
              })
            ) {
              this.optionComboJobType.push({ value: d, text: d })
            }
            // this.optionComboJobType.push({ value: d.comboId, text: d.comboValue })
          })
        }
      })
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Notification',
        autoHideDelay: 5000,
        appendToast: false,
      })
    },
    onSubmit(evt) {
      evt.preventDefault()

      if (this.hasData) {
        // if intId is exist that means data has already at server
        // time to update
        const data = { ...this.form }
        this.updateActivityGeneralWorkFix({ params: data }).then((resp) => {
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
        })
      } else {
        // time to insert
        const data = { ...this.form, submitId: this.submitId }
        this.addActivityGeneralWorkFix({ params: data }).then((resp) => {
          this.hasData = true
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
        })
      }
    },
    onReset(evt) {
      evt.preventDefault()
      this.form = []
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
  },
}
</script>